<!-- OOTB Implementation -->
<div class="parent-text">
  <a class="cstm-anchor-primary" (click)="onVideoClick($event)">
    Click here to see the video
    <strong> <img alt="" src="/images_and_icons/right-arrow.svg"></strong>
  </a>
</div>

<p-dialog [(visible)]="showModal" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  styleClass="cstm-dialog" [style]="{ width: '36vw' }" [draggable]="false" [resizable]="false" [focusOnShow]="false"
  [focusTrap]="false" [dismissableMask]="true" (onHide)="stopVideo()">
  <ng-template pTemplate="content">
    <video #videoPlayer style="width: 100%; height: 100%;" controls controlsList="nodownload">
      <source [src]="(videoUrl$ | async)" type="video/mp4">
    </video>
  </ng-template>
</p-dialog>

<!-- Old Implementation
<div data-toggle="modal" class="parent-text" data-target="#exampleModalLong">
  <a class="cstm-anchor-primary">
    Click here to see the video
    <strong> <img alt="" src="../../../../../assets/images_and_icons/right-arrow.svg"></strong>
  </a>
</div>

<div class="modal fade" tabindex="-1" id="exampleModalLong" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" data-target="#closeVideo" (click)="stopVideo(elRef)"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="closeVideo">
        <video #elRef style="width: 100%; height: 100%;" controls controlsList="nodownload">
          <source src="{{videoUrl}}" type="video/mp4">
        </video>
      </div>
    </div>
  </div>
</div> -->